import React from 'react';
import Overlay from './Overlay';
import { Button, Card } from '@ui';
import { IconCloseX } from '@icons';

interface ModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  id?: string;
  actions?: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'sheet';
  /** Extra classes on the modal window (the `Card` root). */
  className?: string;
}

export const Modal: React.FC<ModalProps> = ({
  open,
  onClose,
  title,
  children,
  id = 'modal-centered',
  actions,
  size = 'md',
  className,
}) => (
  <Overlay open={open} onClose={onClose} id={id} ariaLabelledBy={`${id}-title`}>
    <Card
      className={[
        'modal-window',
        size === 'sheet' ? 'is-sheet size-md' : `size-${size}`,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      role='document'
    >
      <header className='modal-header'>
        <h3 className='modal-title' id={`${id}-title`}>
          {title}
        </h3>
        <Button
          className='btn-close'
          aria-label='Close'
          onClick={onClose}
          as='button'
          type='button'
          icon={<IconCloseX />}
        />
      </header>
      <div className='modal-body'>{children}</div>
      {actions && <footer className='modal-footer'>{actions}</footer>}
    </Card>
  </Overlay>
);

export default Modal;
